import React from "react";

class Footer extends React.Component {
  render() {
    return (
        <footer style={{ backgroundColor: 'var(--color-primary)', minWidth: '100vw', marginTop: '16px' }}>
            {this.props.children}
        </footer>
    );
  }
}

export default Footer;